export function shouldHideAIChat(): boolean {
  const isFoxrenderfarm = window.location.hostname.includes("foxrenderfarm");
  const isFullScreen =
    new URLSearchParams(window.location.search).get("fullScreen") === "true";

  return isFoxrenderfarm || isFullScreen;
}
